"use strict";

var _interopRequireWildcard = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/core-js/modules/es6.array.iterator.js");
require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/core-js/modules/es6.promise.js");
require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/core-js/modules/es6.object.assign.js");
require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/core-js/modules/es7.promise.finally.js");
var _vue = _interopRequireDefault(require("vue"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
require("normalize.css/normalize.css");
require("handsontable/dist/handsontable.full.css");
require("handsontable/languages/zh-CN");
var GillionUI = _interopRequireWildcard(require("ec-light-vue"));
require("element-ui/lib/theme-chalk/index.css");
require("@/styles/index.scss");
require("./assets/iconfont/iconfont.css");
require("@/assets/newiconfont/icon.css");
var _App = _interopRequireDefault(require("./App"));
var _store = _interopRequireDefault(require("./store"));
var _router = _interopRequireDefault(require("./router"));
var _lang = _interopRequireDefault(require("./lang"));
require("./icons");
require("./permission");
require("./utils/error-log");
require("./utils/directive");
var filters = _interopRequireWildcard(require("./filters"));
var _config = _interopRequireDefault(require("./utils/config"));
var _htmlToPdf = _interopRequireDefault(require("@/utils/htmlToPdf"));
var _print = _interopRequireDefault(require("../public/lib/print"));
var _mavonEditor = _interopRequireDefault(require("mavon-editor"));
require("mavon-editor/dist/css/index.css");
var _global = _interopRequireDefault(require("./assets/js/global.js"));
require("@/assets/fonts/iconfont.css");
var _setHotEditCss = _interopRequireDefault(require("@/utils/setHotEditCss"));
var _inputDeleteChinese = _interopRequireDefault(require("@/utils/inputDeleteChinese.js"));
var _hotTableClickEdit = _interopRequireDefault(require("@/utils/hotTableClickEdit.js"));
var _timeSelect = require("@/utils/timeSelect.js");
var _vFitColumns = _interopRequireDefault(require("v-fit-columns"));
var _config2 = require("@/api/common/config");
var _associateConfig = _interopRequireDefault(require("@/utils/associateConfig"));
var _globalComponents = _interopRequireDefault(require("@/componentsBuz/globalComponents"));
var _timeUtil = require("./utils/timeUtil");
var _byteLengthDirective = _interopRequireDefault(require("@/utils/byteLengthDirective"));
var _elementUi = _interopRequireDefault(require("element-ui"));
// a modern alternative to CSS resets
/* handsontable 样式 */

// import './styles/element-variables.scss'
// global css

// internationalization
// icon
// permission control
// error log

// global filters
// config

// pdf

//引入print

// mavon-editor

/**
 * 使用本地开发时，使用动态加载图标方式，当发布到线上时，更新本地fonts图标库，注释动态导入的代码
 */
// 线上环境使用
// 设置hotTable编辑列样式方法

// 设置input判断方法

// 设置hotTable单击进入编译方法

// 设置日期选择时间格式化

// 获取数据字典，多个，传单值，多值用','隔开或者数组

/* 引入全局组件 */

/* 自定义指令限制输入字节长度 */

_elementUi.default.Dialog.props.closeOnClickModal.default = false;
_vue.default.prototype.config = _config.default;
_vue.default.use(_elementUi.default);
_vue.default.use(_print.default);
_vue.default.use(_htmlToPdf.default);
_vue.default.use(_mavonEditor.default);
_vue.default.prototype.GLOBAL = _global.default;

// import { loadStyle, iconfontUrl, iconfontVersion } from '@/utils/font' // 开发环境使用
// /* 动态加载阿里图标字体库 */
// iconfontVersion.forEach(ele => {
//   loadStyle(iconfontUrl.replace('$key', ele))
// })

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  var _require = require("../mock"),
    mockXHR = _require.mockXHR;
  mockXHR();
}
_vue.default.prototype.$setCss = _setHotEditCss.default;
_vue.default.prototype.$inputDeleteChinese = _inputDeleteChinese.default;
_vue.default.prototype.$hotTableClickEdit = _hotTableClickEdit.default;
_vue.default.prototype.$onDateInputDay = _timeSelect.onDateInputDay;
_vue.default.prototype.$onDateInputMinutes = _timeSelect.onDateInputMinutes;
_vue.default.prototype.$onDateInputSecond = _timeSelect.onDateInputSecond;
_vue.default.prototype.$onDateInputMonth = _timeSelect.onDateInputMonth;
_vue.default.use(_vFitColumns.default);
_vue.default.directive('input-delete-chinese', {
  bind: function bind(el, binding) {
    el.addEventListener('input', binding.value);
  },
  unbind: function unbind(el, binding) {
    el.removeEventListener('input', binding.value);
  }
});
_vue.default.directive('byte-length', _byteLengthDirective.default);
_vue.default.use(GillionUI, {
  size: _jsCookie.default.get('size') || 'mini',
  // set element-ui default size
  i18n: function i18n(key, value) {
    return _lang.default.t(key, value);
  },
  loadPermitionMethod: loadPermitionMethod,
  getDictionary: function getDictionary(keyList) {
    return new Promise(function (resolve, reject) {
      var data = {
        codeTypes: keyList.toString()
      };
      (0, _config2.getDictCode)(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  store: _store.default,
  config: _associateConfig.default
});
/* hot-table 解决缓存后表头问题 */
_vue.default.mixin({
  activated: function activated() {
    var _this = this;
    var resizeTo = function resizeTo(key) {
      return _this.$refs[key] && _this.$refs[key].resizeTo && _this.$refs[key].resizeTo();
    };
    Object.keys(this.$refs).forEach(function (key) {
      resizeTo(key);
      _this.activatedTimer = setTimeout(function () {
        return resizeTo(key);
      }, 280);
    });
  },
  deactivated: function deactivated() {
    clearTimeout(this.activatedTimer);
  }
});
// register global utility filters
Object.keys(filters).forEach(function (key) {
  _vue.default.filter(key, filters[key]);
});
_vue.default.config.productionTip = false;
Number.prototype.$toFixed = function (n) {
  var number = this;
  if (isNaN(number) || number >= Math.pow(10, 21)) {
    return number.toString();
  }
  if (typeof n === 'undefined' || n === 0) {
    return Math.round(number).toString();
  }
  var result = number.toString();
  var fixedZero = '';
  var x = Math.pow(10, n);
  var m = result.split('.')[1] ? result.split('.')[1].length : 0;
  var tmpNum = Number(result.replace('.', '')) * x / Math.pow(10, m);
  result = Math.round(tmpNum) / x + fixedZero;
  if (result.split('.').length > 1) {
    var num = result.split('.')[1].length;
    for (var i = num; i < n; i++) {
      result += '0';
    }
  }
  if (result.split('.').length === 1) {
    fixedZero = '.';
    for (var _i = 0; _i < n; _i++) {
      fixedZero += '0';
    }
    result += fixedZero;
  }
  return result;
};

/** 获取权限 */
function loadPermitionMethod(_x) {
  return _loadPermitionMethod.apply(this, arguments);
}
function _loadPermitionMethod() {
  _loadPermitionMethod = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(path) {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            // 从 store 中获取
            var permits = _store.default.state.user.btnPermissions;
            // console.log(permits, path)
            var result = {};
            result.permits = permits.filter(function (item) {
              return item.indexOf(path) !== -1;
            });
            resolve(result);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _loadPermitionMethod.apply(this, arguments);
}
_vue.default.use(_globalComponents.default);
(0, _timeUtil.adpterTimezon)();
var vue = new _vue.default({
  el: '#app',
  router: _router.default,
  store: _store.default,
  i18n: _lang.default,
  render: function render(h) {
    return h(_App.default);
  }
});
window.vm = vue;
// requestDS.js直接import router会报错，所以这边抛出Vue，供数据服务接口的全局过滤器requestDS.js引用
var _default = exports.default = vue;